import { Info, MapPin, Route, Share2, FileText, Settings } from 'lucide-react';
import SurveyInfoTab from './SurveyInfoTab';
import RoutesTab from './RoutesTab';
import POIsTab from './POIsTab';
import ShareTab from './ShareTab';
import FilesTab from './FilesTab';
import SettingsTab from './SettingsTab';

export const TABS = [
  { 
    id: 'info', 
    icon: Info, 
    label: 'Survey Info',
    component: SurveyInfoTab 
  },
  { 
    id: 'routes', 
    icon: Route, 
    label: 'Routes',
    component: RoutesTab 
  },
  { 
    id: 'pois', 
    icon: MapPin, 
    label: 'POIs',
    component: POIsTab 
  },
  {
    id: 'share',
    icon: Share2,
    label: 'Share Survey',
    component: ShareTab
  },
  {
    id: 'files',
    icon: FileText,
    label: 'Files',
    component: FilesTab
  },
  {
    id: 'settings',
    icon: Settings,
    label: 'Settings',
    component: SettingsTab
  }
];

export { 
  SurveyInfoTab,
  RoutesTab, 
  POIsTab,
  ShareTab,
  FilesTab,
  SettingsTab
};